import Vue from 'vue';
import Router from 'vue-router';
import HttpClient from "@/API/HttpClient.ts";
import httpApi from "../API/Sys/Menu";
import Utils from "@/store/utils.ts";
import { join } from 'path';
import Menu from '../API/Sys/Menu';
Vue.use(Router);
/*const syspermission = () => import('../views/sys/permission.vue');
const sysusers = () => import('../views/sys/users.vue');
const sysbillnumber = () => import('../views/sys/billnumber.vue');
const sysdataelement = () => import('../views/sys/data-element.vue');
const sysmenu = () => import('../views/sys/menu.vue');
const sysrole = () => import('../views/sys/role.vue');
const systenants = () => import('../views/sys/tenants.vue');
const tenantsorderpay = () => import('../views/tenants/order-pay.vue');
const tenantsmessagetemplate = () => import('../views/tenants/message-template.vue');
const tenantsappaccount = () => import('../views/tenants/app-account.vue');
const tenantstenantrole = () => import('../views/tenants/tenantrole.vue');
const tenantsusers = () => import('../views/tenants/users.vue');
const tenantsmessagesend = () => import('../views/tenants/message-send.vue');
const loadcomponent=(item: string)=>
{
	switch(item){
		case "syspermission":
			return	syspermission
			break;
		case "sysusers":
			return  sysusers;
			break;
		case "sysbillnumber":
			return  sysbillnumber;
			break;
		case "sysdataelement":
			return  sysdataelement;
			break;
		case "sysmenu":
			return  sysmenu;
			break;
		case "sysrole":
			return  sysrole;
			break;
		case "systenants":
			return  systenants;
			break;
		case "tenantsorderpay":
			return  tenantsorderpay;
			break;
		case "tenantsmessagetemplate":
			return  tenantsmessagetemplate;
			break;
		case "tenantsappaccount":
			return  tenantsappaccount;
			break;
		case "tenantstenantrole":
			return  tenantstenantrole;
			break;
		case "tenantsusers":
			return  tenantsusers;
			break;
		case "tenantsmessagesend":
			return tenantsmessagesend;
			break;
		default:
				break;
	}
}*/
const IndexRouter = [
	{
		path: '/',
		name: 'Login',
		title: '登录',
		component: () => import('../views/Login.vue')
	},
	//浏览卡券列表
	{ path: '/wx-CradDetail', component: () => import('../views/tenants/wxGraphic/wx-CradDetail.vue') },
	//音乐页面 
	{ path: '/wx-MusicDetail', component: () => import('../views/tenants/wxGraphic/wx-MusicDetail.vue') },
	//音频
	{ path: '/wx-VoiceDetail', component: () => import('../views/tenants/wxGraphic/wx-VoiceDetail.vue') },	
	{
		path: '/Application',
		name: 'Application',
		title: '应用号管理',
		component: () => import('../views/Application.vue')
	},
	{
		path: '/refresh',
		name: 'refresh',
		title: '刷新页面',
		component: () => import('../components/refresh.vue')
	},
	{
		path: '/Ueditor',
		name: 'Ueditor',
		title: '刷新页面',
		component: () => import('../components/Ueditor.vue')
	}
];

//加载动态路由

//export let menuList =[];

let tempChi: any = [];
let newTempChi: any = [];

let res = localStorage.getItem('leftMenuMain');
if(res){
	let TempMenuData = Utils.decrypt(res, "");
	if (TempMenuData) {
		let MenuData = JSON.parse(TempMenuData);
		console.log(MenuData);
		MenuData.forEach((item:any, index:number, array:any) => {
			let childTem:any = [];
			item.children.forEach((childItem:any, childIndex:number, array:any) => {
				childItem.children.forEach((childrenItem:any, childrenIndex:number, array:any) => {
					if (childrenItem.path != "/") {
						let p: any = {};
						if (childrenItem.param != null && childrenItem.param != "") {
							p = "(" + childrenItem.param + ")";
						}
						let childrenTempValue = {
							path: childrenItem.path,
							name: childrenItem.path,
							title: childrenItem.title,
							parentcode: childrenItem.parentcode,
							meta: p,
							component: () => import('../views' + childrenItem.path + '.vue')// loadcomponent(tempcomponent)
						}
						childTem.push(childrenTempValue);
					}
				});
				if (childItem.path != "/") {
					let param = {};
					if (childItem.param != null && childItem.param != "") {
						param = eval("(" + childItem.param + ")");
					}
					let childTempValue = {
						path: childItem.path,
						name: childItem.path,
						title: childItem.title,
						parentcode:childItem.parentcode,
						meta: param,
						component: () => import('../views' + childItem.path + '.vue')// loadcomponent(tempcomponent)
					}
					childTem.push(childTempValue);
					if (childItem.name == 'M161') {
						//加修改的动态路由
						let tempValue = { path: '/MangeCenter/Manage_EditAccount/:id', component: () => import('../views/MangeCenter/Manage_EditAccount.vue') }
						childTem.push(tempValue);
						//加应用号
						let tempValue2 ={ path: '/mangecenter/Manage_AddAccount', component: () => import('../views/MangeCenter/Manage_AddAccount.vue') }
						childTem.push(tempValue2);
					}
				}
			});
			if (item.path.indexOf("/main/") < 0 && item.path != "/") {
				let param = {};
				if (item.param != null && item.param != "") {
					param = eval("(" + item.param + ")");
				}
				let tempValue = {
					path: item.path,
					name: item.path,
					title: item.title,
					parentcode:item.parentcode, 
					meta: param,
					component: () => import('../views' + item.path + '.vue'),
					children: childTem
				}
				newTempChi.push(tempValue);
			}
		});
	}
}

var defaultRouter = {
	path: '/main',
	name: 'main',
	title: '主页',
	component: () => import('../views/Main.vue'),
	children: newTempChi
	// [
	// 	{
	// 		path: '/main/:name/',
	// 		name: 'maincontent',
	// 		title: '主页',
	// 		component: () => import('../views/MainContent.vue')
	// 		, children: tempChi
	// 	}
	// ]
};

IndexRouter.push(defaultRouter); 
IndexRouter.push({
	path: '*',
	name: '404',
	title: '页面走丢了',
	component: () => import('../views/404.vue')
});
// console.log(IndexRouter);
export default new Router({
	mode: 'history', // require service support
	base: process.env.BASE_URL,
	routes: IndexRouter,
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location:any) {
return (originalPush.call(this, location) as any).catch((err:any) => err);
}


